<template>
    <span>
      <!-- Card layout for each items -->
      <!-- Card layout requires: title, style, icon, text -->
      <div v-if="extraItem.cardLayout">
        <div class="font-weight-bold">{{ extraItem.title }}</div>
        <v-container>
          <v-row class="text-center justify-center" v-for="i in numberRows" :key="i + '-i'" >
            <v-col v-for="j in numCols" :key="j + '-j'"
              cols="12" 
              :lg="12 / numCols" 
              :xl="12 / numCols" 
            >
              <div class="d-flex">
                <v-card class="mx-auto card-item experience-card-item"
                        v-if="getItemIdx(i, j) < extraItem.items.length"
                >
                  <v-card-title class="justify-center">
                    <div>
                      <font-awesome-icon :icon="[extraItem.items[getItemIdx(i, j)].style, extraItem.items[getItemIdx(i, j)].icon]" class="mr-3" />
                    </div>
                    <div class="standard-text-sizing text-break-word">
                      {{ extraItem.items[getItemIdx(i, j)].title }}
                    </div>
                  </v-card-title>
                  <v-card-text v-html="extraItem.items[getItemIdx(i, j)].text" />
                </v-card>
              </div>
            </v-col>
          </v-row>
        </v-container>
      </div>
      <!-- Standard list layout -->
      <div v-else>
        <p class="font-weight-bold">{{ extraItem.title }}</p>
        <ul>
            <li v-for="item in extraItem.items" :key="item.text" v-html="item.text" />
        </ul>
      </div>
    </span>
</template>

<script>
  export default {
    name: 'ExperienceItem',
    props: {
        extraItem: Object,    
    },
    data: function() {
      return {
        numCols: 3,
        numberRows: Math.ceil(this.extraItem.items.length / 3)
      };
    },
    methods: {
      getItemIdx(i, itemNum) {
        return (3 * (i - 1)) + (itemNum - 1);
      }
    }
  }
</script>

<style lang="scss">
@import 'src/assets/scss/global.scss';

// xs, sm and md screen widths
@media screen and (max-width: 1263px)
{
  // if cols-12 for each experience extra item card, then extend width to 100%
  // only lg and xl screen widths are not col-12
  .experience-card-item {
    width: 100%
  }
}

</style>

